import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

const getDefaultSelectedItem = () => {
  return {
    itemType: {},
    itemProperties: [],
    cabinClassId: null,
    saleable: false,
  };
};

export default {
  state: () => ({
    selectedItem: getDefaultSelectedItem(),
    items: [],
    itemsMap: {},
    totalImageCountFromResponse: 0,
  }),

  mutations: {
    setSelectedItem(state, item) {
      Vue.set(state, "selectedItem", item);
    },
    setItems(state, items) {
      Vue.set(state, "items", items);
    },
    setItemsMap(state, itemsMap) {
      Vue.set(state, "itemsMap", itemsMap);
    },
    setDefaultSelectedItem(state) {
      Vue.set(state, "selectedItem", getDefaultSelectedItem());
    },
    setTotalImageCountFromResponse(state, totalImageCountFromResponse) {
      Vue.set(state, "totalImageCountFromResponse", totalImageCountFromResponse);
    },
    setDefaultItemModule(state) {
      Vue.set(state, "selectedItem", getDefaultSelectedItem());
      Vue.set(state, "items", []);
      Vue.set(state, "itemsMap", {});
      Vue.set(state, "totalImageCountFromResponse", 0);
    },
  },

  actions: {
    //TODO: load, update, create
    createItem: (context, request) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/items/entity", request, {})
        .then((response) => {
          //TODO: Loader end
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    uploadImage: (context, request, config = { headers: { "Content-Type": "multipart/form-data" } }) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/storage/upload/item", request, config)
        .then((response) => {
          //TODO: Loader end
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    uploadAgencyImage: (context, request) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/storage/upload/agency", request, {})
        .then((response) => {
          //TODO: Loader end
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadItems: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/items/entity").then((response) => {
        context.commit("setItems", response.data);
        return response.data;
      });
    },
    loadPublishedItems: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/items/entity/published").then((response) => {
        //TODO: Loader koyulacak
        context.commit("setItems", response.data);
        return response.data;
      });
    },
    loadActiveItems: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/items/actives").then((response) => {
        //TODO: Loader koyulacak
        context.commit("setItems", response.data);
        return response.data;
      });
    },
    loadItemsInTMS: (context) => {
      return axios.get(context.getters.getTmsCdnServiceUrl + "/items.json").then((response) => {
        return response.data;
      });
    },
    loadItemHistory: (context, request) => {
      //TODO: Loader start
      return axios.post(context.getters.getMcServiceUrl + "/items/entity/history/search", request, {}).then((response) => {
        //TODO: Loader end
        return response.data;
      });
    },
    loadSelectedItemHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/items/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },
    loadUsedItemInformationList: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/items/seat-map-template/item").then((response) => {
        return response.data;
      });
    },

    deleteItem: (context, item) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/items/entity/" + item.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          item.intents = intents;
          item.intentId = response.data.id;
          return item;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftItem: (context, item) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/items/draft/" + item.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    publishItem: (context, item) => {
      return axios.get(context.getters.getMcServiceUrl + "/items/publish/" + item.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },
    rejectItem: (context, item) => {
      return axios.get(context.getters.getMcServiceUrl + "/items/reject/" + item.intentId).then((response) => {
        if (item.intents[0].type === "DELETE_ITEM") {
          item.intents = null;
          item.intentId = 0;
        } else if (item.intents[0].type === "CREATE_ITEM") {
          item.intents[0].status = "DRAFT";
        } else if (item.intents[0].type === "UPDATE_ITEM") {
          item.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },
    sendToApprovalItem: (context, item) => {
      return axios.get(context.getters.getMcServiceUrl + "/items/sendToApproval/" + item.intentId).then((response) => {
        if (item.intents[0].type === "CREATE_ITEM") {
          item.intents[0].status = "WAITING_APPROVAL";
        } else if (item.intents[0].type === "UPDATE_ITEM") {
          item.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallItem: (context, item) => {
      return axios.get(context.getters.getMcServiceUrl + "/items/recall/" + item.intentId).then((response) => {
        helper.recallOrRejectEntity(item, "item");
        return response.data;
      });
    },

    cancelItem: (context, item) => {
      return axios.get(context.getters.getMcServiceUrl + "/items/cancel/" + item.intentId).then((response) => {
        return response.data;
      });
    },
    uploadBlacklistFile: (context, request, config = { headers: { "Content-Type": "multipart/form-data" } }) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/storage/upload/blacklist", request, config)
        .then((response) => {
          //TODO: Loader end
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    uploadOtherFile: (context, request, config = { headers: { "Content-Type": "multipart/form-data" } }) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/storage/upload/other", request, config)
        .then((response) => {
          //TODO: Loader end
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    uploadNotificationFile: (context, request, config = { headers: { "Content-Type": "multipart/form-data" } }) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/storage/upload/notification", request, config)
        .then((response) => response)
        .catch((err) => err.response);
    },
    downloadOtherFile: (context, { fileUrl }) => {
      const cleanFileUrl = (fileUrl || "").split("?")[0];
      return axios
        .get(context.getters.getMcServiceUrl + "/storage/download/other", {
          params: {
            environment: "dev",
            fileUrl: cleanFileUrl,
          },
          responseType: "arraybuffer",
          headers: {
            Accept: "application/octet-stream, image/*, application/pdf, */*",
          },
        })
        .then((response) => {
          const data = response.data;
          if (!data || data.byteLength === 0) {
            throw new Error("Dosya bos");
          }
          const contentType = (response.headers["content-type"] || "application/octet-stream").split(";")[0].trim();
          if (contentType.includes("application/json") || (data.byteLength > 0 && new Uint8Array(data)[0] === 123)) {
            const text = new TextDecoder().decode(data);
            throw new Error(text || "Dosya indirilemedi");
          }
          return new Blob([data], { type: contentType });
        });
    },
  },
  getters: {
    getSelectedItem: (state) => {
      return state.selectedItem;
    },
    getItems: (state) => {
      return state.items;
    },
    getItemsMap: (state) => {
      return state.itemsMap;
    },
    getTotalImageCountFromResponse: (state) => {
      return state.totalImageCountFromResponse;
    },
  },
};
